import { GroupType } from '../../model/enumerations';

DateRangePreprocessorFactory.$inject = [
	'mx.shell.SearchProviderService',
	'mx.SolutionBuilderAgent.BasePreprocessor',
	'mx.sb.Agent.DataQuery.FilterOperatorsFactory',
	'mx.SolutionBuilderAgent.SearchQueryGroup',
	'mx.SolutionBuilderAgent.SearchQueryCondition',
];
export default function DateRangePreprocessorFactory(searchService, BasePreprocessor, filterOperatorsFactory, SearchQueryGroup, SearchQueryCondition) {
	class DateRangePreprocessor extends BasePreprocessor {
		constructor() {
			super();
			this.type = mx.SolutionBuilderAgent.PreprocessorType.DateRange;
			return this;
		}

		build() {
			this._addRangeGroupIntoSearch();
		}

		init(executor, parameters, dataQueryList) {
			super.init(executor, parameters, dataQueryList);
			this.dateRangeGroup = this._getDateRangeSearchGroup(parameters);
			let startDate;
			let endDate;

			Object.defineProperties(this, {
				startDate: {
					get: function () {
						return startDate;
					},
					set: function (newDate) {
						startDate = newDate;
						this.dateRangeGroup.groups[0].conditions[0].value = [startDate, ''];
						this.dateRangeGroup.groups[1].conditions[0].value = [startDate, ''];
						this.dateRangeGroup.groups[2].conditions[0].value = ['', startDate];
					},
				},
				endDate: {
					get: function () {
						return endDate;
					},
					set: function (newDate) {
						endDate = newDate;
						this.dateRangeGroup.groups[0].conditions[1].value = ['', endDate];
						this.dateRangeGroup.groups[1].conditions[1].value = ['', endDate];
						this.dateRangeGroup.groups[2].conditions[1].value = [endDate, ''];
					},
				},
			});
		}

		_addRangeGroupIntoSearch() {
			searchService.currentSearch().searchForm.setGroup(this.dateRangeGroup, GroupType.DateRange);
		}

		_getDateRangeSearchGroup(parameters) {
			/*
			event.start >= start 	&& event.start < end ||
			event.end 	> start 	&& event.end  <= end  ||
			event.start < start	 	&& event.end   > end
			*/
			const group = new SearchQueryGroup({
				LogicalOperator: mx.SolutionBuilderAgent.SearchQueryLogicalOperator.OR,
			});

			const startInRangeGroup = new SearchQueryGroup();
			startInRangeGroup.addCondition(this._createCondition(parameters, parameters.calendar.startDateKey));
			startInRangeGroup.addCondition(this._createCondition(parameters, parameters.calendar.startDateKey));

			const endInRangeGroup = new SearchQueryGroup();
			endInRangeGroup.addCondition(this._createCondition(parameters, parameters.calendar.endDateKey));
			endInRangeGroup.addCondition(this._createCondition(parameters, parameters.calendar.endDateKey));

			const moreThanRangeGroup = new SearchQueryGroup();
			moreThanRangeGroup.addCondition(this._createCondition(parameters, parameters.calendar.startDateKey));
			moreThanRangeGroup.addCondition(this._createCondition(parameters, parameters.calendar.endDateKey));

			group.addGroup(startInRangeGroup);
			group.addGroup(endInRangeGroup);
			group.addGroup(moreThanRangeGroup);

			return group;
		}

		_createCondition(parameters, columnName) {
			const column = parameters.dataQuery.Columns.find(function (column) {
				return column.Name === columnName;
			});
			const condition = new SearchQueryCondition({
				Property: column.Name,
				Type: column.AttributeSearchValueType,
				Operator: filterOperatorsFactory.operators.Between.value,
			});
			condition.__property = column;
			return condition;
		}
	}

	return DateRangePreprocessor;
}
